import './TrustSection.css';

const stats = [
  {
    bold: '24×7',
    label: 'live rails',
    body: 'IMPS, NEFT, RTGS and UPI, running every hour of the day.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M30.6665 5.75H40.2498V15.3333" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.6665 38.3333L40.2498 5.75" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M40.2498 30.667V40.2503H30.6665" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28.75 28.75L40.25 40.25" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M7.6665 7.66699L17.2498 17.2503" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    bold: 'T+0',
    label: 'settlement',
    body: 'Funds reach the beneficiary the same day, wherever the rail allows.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M23 40.25C32.5269 40.25 40.25 32.5269 40.25 23C40.25 13.4731 32.5269 5.75 23 5.75C13.4731 5.75 5.75 13.4731 5.75 23C5.75 32.5269 13.4731 40.25 23 40.25Z" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23 13.417V23.0003L28.75 26.8337" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    bold: '99.9%',
    label: 'uptime SLA',
    body: 'Multi-bank routing with failover when a bank slows down.',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="43" height="39" viewBox="0 0 43 39" fill="none">
        <path d="M40.2498 19.167H32.5832L26.8332 36.417L15.3332 1.91699L9.58317 19.167H1.9165" stroke="#0043FE" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
  },
  {
    heading: 'PMLA and RBI grievance redressal',
    body: 'Nodal officer details and the escalation path are published.',
    dark: true,
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
        <path d="M23.0001 42.1663C23.0001 42.1663 38.3334 34.4997 38.3334 22.9997V9.58301L23.0001 3.83301L7.66675 9.58301V22.9997C7.66675 34.4997 23.0001 42.1663 23.0001 42.1663Z" stroke="#99FE00" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        <g transform="translate(17.25 19.17)">
          <path d="M1.91675 5.75033L5.75008 9.58366L13.4167 1.91699" stroke="#99FE00" strokeWidth="3.83333" strokeLinecap="round" strokeLinejoin="round"/>
        </g>
      </svg>
    ),
  },
];

export default function TrustSection() {
  return (
    <section className="trust">
      <div className="trust__container">
        <header className="trust__header">
          <p className="trust__eyebrow">Trust and proof</p>
          <h2 className="trust__heading">Built on rails you can verify</h2>
          <p className="trust__subheading">The infrastructure behind every payout, and the details you can check for yourself.</p>
        </header>

        <div className="trust__grid">
          {stats.map((stat, i) => (
            <article key={i} className={`trust__card${stat.dark ? ' trust__card--dark' : ''}`}>
              <div className="trust__icon-wrapper">{stat.icon}</div>
              <div className="trust__card-body">
                {stat.heading ? (
                  <>
                    <p className="trust__card-heading">{stat.heading}</p>
                    <p className="trust__body">{stat.body}</p>
                  </>
                ) : (
                  <>
                    <p className="trust__stat">
                      {stat.bold}
                      <span className="trust__stat-label">{stat.label}</span>
                    </p>
                    <p className="trust__body">{stat.body}</p>
                  </>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
